<script>
  import { LayerCake, Svg } from "layercake";

  import SankeyFlow from "./SankeyFlow.svelte";

  export let data;
  export let sticky;
  let show = false;

  let wrapper_data;
  $: {
    data;
    if (data) {
      show = false;
      wrapper_data = data;
      // console.log('wrapper_data: ', wrapper_data);
      show = true;
    }
  }
</script>

{#if show}
  <LayerCake data={wrapper_data} style="z-index: 4;">
    <Svg style="z-index: 5;">
      <SankeyFlow colorNodes={() => "#00bbff"} {sticky} colorLinks={() => "#00bbff35"} />
    </Svg>
  </LayerCake>
{/if}

<style>
  /*
    The wrapper div needs to have an explicit width and height in CSS.
    It can also be a flexbox child or CSS grid element.
    The point being it needs dimensions since the <LayerCake> element will
    expand to fill it.
  */
</style>
